import {
    $, addAction, doAction, INIT,
} from '@situation/setdesign.util';

function getMessageMatch(url, list) {
    let message = '';

    for (let i = 0, len = list.length; i < len; i += 1) {
        const match = list[i];
        const pattern = match.url_match;
        if (url.indexOf(pattern) > -1 || new RegExp(pattern).test(url)) {
            if (match.message) {
                message = match.message;
                break;
            }
        } else if (match.url_match === '') {
            message = match.message;
        }
    }
    return message;
}

addAction(INIT, () => {
    const urlMatches = window.sit.linkInterrupters || [];
    if (!urlMatches.length) {
        return;
    }

    const $modal = $('#continue-navigation');
    $modal.find('.interrupter__target').on('click', () => {
        setTimeout(() => {
            doAction('hideModal', $modal);
        }, 1000);
    });

    $('a[href]')
        .filter((i, el) => {
            const $this = $(el);
            if (
                el.host === window.location.host
                || $this.closest('.fc-event, .ticket-calendar, .modal--interrupter').length
            ) {
                return false;
            }

            const href = $this.attr('href');
            const message = getMessageMatch(href, urlMatches);
            if (!message) {
                return false;
            }

            $this.data({ href, message }).attr('href', '#continue-navigation');
            return true;
        })
        .on('click', (e) => {
            const $this = $(e.currentTarget);
            $modal.find('.interrupter__content > p').html($this.data('message'));
            $modal.find('.interrupter__target').attr('href', $this.data('href'));
        });
});
